
export const iopScienceNav = [
      // {
      //       title: 'Dashboard',
      //       fafa: 'fa fa-fw fa-dashboard',
      //       id: 'think_dashboard',
      //       childId: 'think_dashboardChildID',
      //       childIdHash: '#think_dashboardChildID',
      //       routerLink: ['counter5-dashboard'],
      //       disabled: false,
      //       visible: true,
      // },
      {
            title: 'Home',
            fafa: 'fa fa-fw fa-dashboard',
            id: 'think_dashboard',
            childId: 'think_dashboardChildID',
            childIdHash: '#think_dashboardChildID',
            routerLink: ['insight-dashboard'],
            disabled: false,
            visible: false,
      },
      {
            title: 'Processing',
            fafa: 'fa fa-tasks',
            id: 'headingProcessing',
            childId: 'processingSubMenu',
            childIdHash: '#processingSubMenu',
            disabled: false,
            visible: false,
            children: [{
                  title: 'Archive of Feeds',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/archive_of_feeds'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'Quality Assurance',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/quality_assurance'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'Push Live and Roll Back',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/push_live_and_roll_back'],
                  disabled: false,
                  visible: false,
            },
                  //  {
                  //       title: 'Dynamic Report',
                  //       fafa: 'fa fa-angle-right',
                  //       routerLink: ['insight/dynamic_report'],
                  //       disabled: false,
                  //       visible: false,
                  //       // }, {
                  //       //       title: 'Favorites',
                  //       //       fafa: 'fa fa-angle-right',
                  //       //       routerLink: ['insight/favorites'],
                  //       //       disabled: false,
                  //       //       visible: false,
                  // }
            ]
      },
      {
            title: 'Usage Reports',
            fafa: 'fa fa-tasks',
            id: 'headingProcessing',
            childId: 'usageSubMenu',
            childIdHash: '#usageSubMenu',
            routerLink: ['insight/static_reports'],
            disabled: false,
            visible: false,
            // children: [{
            //       title: 'Static Reports',
            //       fafa: 'fa fa-angle-right',
            //       routerLink: ['insight/static_reports'],
            //       disabled: false,
            //       visible: false,
            // }, {
            //       title: 'Dynamic Report',
            //       fafa: 'fa fa-angle-right',
            //       routerLink: ['insight/dynamic_reports1'],
            //       disabled: false,
            //       visible: false,
            // }]
      },
      {
            title: 'Manage Accounts',
            fafa: 'fa fa-tasks',
            id: 'headingManageAccounts',
            childId: 'ManageAccountsSubMenu',
            childIdHash: '#ManageAccountsSubMenu',
            disabled: false,
            visible: false,
            children: [{
                  title: 'Manage Sushi',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/manage_sushi'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'Email Alerts',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/email_alert'],
                  disabled: false,
                  visible: false,
            }
            ]
      },
      {
            title: 'Accounts',
            fafa: 'fa fa-calculator',
            id: 'headingAccount',
            childId: 'accountsSubMenu',
            childIdHash: '#accountsSubMenu',
            disabled: false,
            visible: false,
            children: [{
                  title: 'Accounts',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/accounts'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'Favorites',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/favorites'],
                  disabled: false,
                  visible: false,
            }]
      }, {
            title: 'User Management',
            fafa: 'fa fa-tasks',
            id: 'headingUserManagement',
            childId: 'usermanagementSubMenu',
            childIdHash: '#usermanagementSubMenu',
            disabled: false,
            visible: false,
            children: [{
                  title: 'Publisher User',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/publisher_users'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'Library User',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/Library_users'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'Role',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/role'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'Create and Manage SUSHI Partners',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/SUSHI_partners'],
                  disabled: false,
                  visible: false,
            }]
      }, {
            title: 'Publisher Setup',
            fafa: 'fa fa-cogs',
            id: 'headingPubisherSetup',
            childId: 'pubisherSetupSubMenu',
            childIdHash: '#pubisherSetupSubMenu',
            disabled: false,
            visible: false,
            children: [{
                  title: 'Manage Favorites',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/manage_favorites'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'Manage Email Alerts',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/email_alerts'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'Manage Push Live Settings',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/push_live'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'Manage Library Configuration Options',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/lib_config'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'Configure Reports For Librarians',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/configure_reports'],
                  disabled: false,
                  visible: false,
            }]
      }, {
            title: 'Publisher Reports',
            fafa: 'fa fa-file-text',
            id: 'headingPublisherReports',
            childId: 'visiblePufalse',
            childIdHash: '#visiblePufalse',
            routerLink: ['insight/publisher_reports'],
            disabled: false,
            visible: false,
      }, {
            title: 'Tools',
            fafa: 'fa fa-link',
            id: 'headingTools',
            childId: 'visibleTools',
            childIdHash: '#visibleTools',
            //href: 'https://datool.mpsinsight.com/da/flow.html?_flowId=searchFlow',
            // routerLink: ['insight/tools'],
            disabled: false,
            visible: false,
            children: [{
                  title: 'Click To Redirect Tools',
                  fafa: 'fa fa-angle-right',
                  href: 'https://datool.mpsinsight.com/da/flow.html?_flowId=searchFlow',
                  disabled: false,
                  visible: true,
            }]
      }, {
            title: 'Sales',
            fafa: 'fa fa-link',
            id: 'headingSales',
            childId: 'saleSubMenu',
            childIdHash: '#saleSubMenu',
            disabled: false,
            visible: false,
            children: [{
                  title: 'Trials',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/trials'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'Sales Report',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/sales_report'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'Account Search',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/account_search'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'Create and Manage Sales Users',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/create_and_manage_sales_users'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'Publisher Level Report Threshold Setting',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/publisher_level_report_threshold_setting'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'Seasonality Adjustment',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/seasonality_adjustment'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'User Administration',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/user_administration'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'User Saved Query',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/user_saved_query'],
                  disabled: false,
                  visible: false,
            }]
      }, {
            title: 'Support',
            fafa: 'fa fa-info-circle',
            id: 'headingSupport',
            childId: 'supportSubMenu',
            childIdHash: '#supportSubMenu',
            disabled: false,
            visible: false,
            children: [{
                  title: 'Contact Us',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/contactus_insight'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'FAQs',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/faqs-iopscience'],
                  // routerLink: ['insight/faqs-ieee'],
                  disabled: false,
                  visible: false,
            }, {
                  title: 'View Issue Tracker',
                  fafa: 'fa fa-angle-right',

                  href: 'http://support.mpsinsight.com/secure/Dashboard.jspa',
                  disabled: false,
                  visible: false,
            }, {
                  title: 'System Log',
                  fafa: 'fa fa-angle-right',
                  routerLink: ['insight/system_log'],
                  disabled: false,
                  visible: false,
            }]
      },
];



// WEBPACK FOOTER //
// ./src/app/pages/left-nav/nav.iopscience.ts